import $ from "jquery";
import Swiper from 'swiper/bundle';
// import Swiper, { Navigation, Pagination } from "swiper";
// // configure Swiper to use modules
// Swiper.use([Navigation, Pagination]);
import 'swiper/css/bundle';

window.$ = $;
window.Swiper = Swiper;

$(document).on('click', '.videotest', function(event) {
  logVideoCompletion(this);
});

async function logVideoCompletion(modal) {
  let node = modal.closest("div.teaser").id;

  let mediaID = 0;
  if ($(modal).data('video-modal')) {
    mediaID = $(modal).data('media-id')
  }

  const modalIds = JSON.parse(sessionStorage.getItem('modalIds') || '[]');

  if (modalIds.includes(node)) {
    console.log(`modal complete has already been logged for ${node}`);
    return false;
  }
  console.log(`modal complete is logging for ${node}`);

  modalIds.push(node);
  sessionStorage.setItem('modalIds', JSON.stringify(modalIds));

  try {
    const response = await fetch(`/video/${node}/${mediaID}/completion`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({video_id: node}),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

$(window).on('load', function (event) {

	//Mobile menu
	$('.hamburger').on('click', function() {
		$('html').toggleClass('noscroll');
		$(this).toggleClass('is-active');
		$('.header__bottom').toggleClass('is-active');
	});

	// toggle login area dropdown
	$('.loginarea__user button').on('click', function() {
		$(this).parent().toggleClass('is-active');
	});

  $('.optin-banner__close, .optin-banner__button').on('click', function() {
    popupDismiss();
  });

  async function popupDismiss() {
    console.log($('.optin-banner').attr('popup-id'));
    try {
      const response = await fetch('/popups/dismiss', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({popup_id: $('.optin-banner').attr('popup-id')}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      $('.optin-banner').remove();
    } catch (error) {
      console.error('Error:', error);
    }
  }

  if ($('.alert-banner').is(':visible')) {
    $('.header').css('top', '50px');
  }

	// Spec tabs
	$('.tab__title').on('click', function() {

		var ww = $(window).width(),
				tab = $(this).attr('data-control');

		if(ww < 768) {
			if($(this).parent().hasClass('is-active')) {
				// Remove active state if clicked
				$('.spec,.overview,.tab').removeClass('is-active');
			} else {
				// Remove any active
				$('.spec,.overview,.tab').removeClass('is-active');
				// Set active from clicked
				$(this).parent().addClass('is-active');
				$('#'+tab).addClass('is-active');
			}
		}
	});

	//Swiper
	// Home carousel
	const homeswiper = new Swiper('.carousel__top .swiper', {
		loop:true,
		autoplay: {
			delay: 5000,
		},
		navigation: {
			nextEl: '.carousel__top .swiper-button-next',
			prevEl: '.carousel__top .swiper-button-prev',
		},
		pagination: {
			el: '.carousel__top .swiper-pagination',
			type: 'bullets',
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + '<i></i>' + '<b></b>'  + '</span>';
			},
		},
	});

	// Product toolkit
	let slidesToLoop = $('.productSwiper--thumbnails').attr('data-slide-total');

	//Product toolkit thumbnails
	const thumbSwiper = new Swiper(".productSwiper--thumbnails", {
    loop: false,
    centeredSlides: true,
    spaceBetween: 8,
    slidesPerView: 5,
    freeMode: false,
    watchOverflow: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loopedSlides: slidesToLoop,
  });

	//Product toolkit large
	const productSwiper = new Swiper(".productSwiper--large", {
    loop: false,
    spaceBetween: 10,
    watchOverflow: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
      thumbsContainerClass: "swiper-container-left-aligned",
    },
    loopedSlides: slidesToLoop,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
    },
  });

	productSwiper.on("slideChange", () => {
		thumbSwiper.slideTo(productSwiper.activeIndex);
	});


	$('.swiper--play').hide();

	$('.swiper--play').on('click', () => {
		console.log('resuming')
		homeswiper.autoplay.resume()
		$('.swiper--play').hide();
		$('.swiper--pause').show();
	});
	$(".swiper--pause").on("click", () => {
		console.log('pausing')
    homeswiper.autoplay.pause()
		$('.swiper--pause').hide();
		$('.swiper--play').show();
  });

	//Latest products and solutions
	const productSolutions = new Swiper(".latestProducts__carousel .swiper", {
    loop: true,
		slidesPerView: 1,
		spaceBetween: 16,
    watchOverflow: true,
    navigation: {
      nextEl: ".latestProducts__carousel .swiper-button-next",
      prevEl: ".latestProducts__carousel .swiper-button-prev",
    },
    pagination: {
      el: ".latestProducts__carousel .swiper-pagination",
      type: "bullets",
    },
		breakpoints: {
			768: {
				slidesPerView: 2
			},
			1090: {
				slidesPerView: 3
			}
		}
  });

	const trainingSwiperLength = $('.training__carousel .swiper .swiper-slide').length
	if (trainingSwiperLength >= 3) {
		const trainingSwiper = new Swiper(".training__carousel .swiper", {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 15,
			watchOverflow: true,
			navigation: {
				nextEl: ".training__carousel .swiper-button-next",
				prevEl: ".training__carousel .swiper-button-prev",
			},
			pagination: {
				el: ".training__carousel .swiper-pagination",
				type: "bullets",
			},
			breakpoints: {
				768: {
					slidesPerView: 1
				},
				1090: {
					slidesPerView: 3
				}
			}
		});
	} else if (trainingSwiperLength == 1) {
		$('.training__carousel .swiper .swiper-wrapper').addClass('swiper-wrapper--single')
		$(".training__carousel .controls__wrapper, .training__carousel .swiper-button-prev, .training__carousel .swiper-button-next").remove();
	} else {
		$('.training__carousel .swiper .swiper-wrapper').addClass('swiper-wrapper--double')
		$('.training__carousel .controls__wrapper, .training__carousel .swiper-button-prev, .training__carousel .swiper-button-next').remove()
	}


	const eventSlider = new Swiper('.events__carousel .swiper', {
		loop:false,
		slidesPerView:1,
		spaceBetween: 16,
		watchOverflow:true,
		navigation: {
			nextEl: ".events__carousel .swiper-button-next",
			prevEl: ".events__carousel .swiper-button-prev",
		},
		pagination: {
			el: ".events__carousel .swiper-pagination",
			type: "bullets",
		},
	})

	// Toolkit content shift
	var originalParent = $(".product__additional").parent();
    function checkWidthAndMoveDiv() {
        if ($(window).width() >= 980) {
            $(".product__additional").appendTo(".product__excerpt");
        } else {
            $('.product__additional').appendTo(originalParent);
        }
    }
		checkWidthAndMoveDiv();
    window.addEventListener('resize', checkWidthAndMoveDiv);

	function submenuHeight() {
		const submenus = document.querySelectorAll('.submenu__wrapper');
		let totalHeight = 0;

		submenus.forEach(function(submenu) {
			totalHeight += submenu.offsetHeight;
		});

		const toolkitSubmenu = document.querySelector('.toolkit__submenu');
		//toolkitSubmenu.style.height = totalHeight + 'px';
	}
	submenuHeight();
	window.addEventListener("resize", submenuHeight);


	// submenu offset
	function submenuOffset() {
		const submenus = document.querySelectorAll(".submenu__wrapper");
		for (let i = 1; i < submenus.length; i++) {
			const prevHeight = submenus[i - 1].offsetHeight;
			//submenus[i].style.top = prevHeight + 'px';
		}
	}
	submenuOffset();
	window.addEventListener('resize', submenuOffset);

	// Submenu function
	if ($(window).width() >= 980) {

	} else {
		var hasChildren = document.querySelectorAll('.has-children');

    hasChildren.forEach(function(element) {
        var pseudoElement = window.getComputedStyle(element, '::after');
        element.addEventListener('click', function(event) {
            if (event.target === this || event.target === pseudoElement) {
                this.classList.toggle('open');
            }
        });
    });
	}
});

$( ".submenu__wrapper--grey" ).on( "click", function() {

} );

$('body').on('click', '.submenu__wrapper--grey .bef-link', function() {
  console.log("hello world");
  $( ".bef-exposed-form" ).addClass('bef-link--selected--margin-large');
});

$('#views-exposed-form-toolkits-toolkits').ajaxComplete(function(event, xhr, settings) {
  if ($(event.target.id) == 'the-id-of-your-item') {
    console.log("hello world 2");
  }
});
